import actions from "../../reducers/registrationForm/registrationFormActions";
import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, Icon, IconButton, LinearProgress,
    Paper, TextField, Tooltip, Typography
} from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import RestoreFromTrashOutlinedIcon from '@material-ui/icons/RestoreFromTrashOutlined';
import RegistrationToolbar from "./RegistrationToolbar";
import CountrySelect from "../CountrySelect/CountrySelect";
import {lookupCountry} from "../CountrySelect/CountryList";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import jwt_decode from "jwt-decode";
import AddEntryDialog from "./AddEntryDialog";
import registrationFormActions from "../../reducers/registrationForm/registrationFormActions";

const style = theme => ({
    root: {
        width: '100%'
    },
    textField: {
    },
    typographyTop: {
        padding: '12px 24px 4px 24px'
    },
    typographyRegistrationClosed: {
        padding: '12px 24px 4px 24px'
    },
    typography: {
        padding: '4px 24px 4px 24px'
    },
    grid: {
        paddingLeft: 24,
        paddingRight: 24
    },
    submitBar: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(1)
    },
    submitButton: {
        marginRight: 24,
        // "&:disabled": {
        //     backgroundColor: fade(theme.palette.primary.light, 0.5)
        // }
    },
    disabledSubmitButton: {
        backgroundColor: theme.palette.primary.light || 'red',
        fontWeight: "bold"
    },
    bottomForm: {
        marginTop: theme.spacing(3)
    },
    errorBar: {
        backgroundColor: theme.palette.error.dark
    },
    deletedEntry: {
        textDecoration: 'line-through'
    }
});

class RegistrationForm extends Component {
    state = {
        formValid: false,
        errors: {
            name: false,
            phone: false,
            email: false
        }
    };

    handleChange = (name, event) => {
        switch (name) {
            case 'name':
                this.props.setName(event.target.value);
                break;
            case 'phone':
                this.props.setPhone(event.target.value);
                break;
            case 'email':
                this.props.setEmail(event.target.value);
                break;
            default:
                break;
        }
    };

    handleOnFocus = (item) => {
        this.setState({focus: item});
    };

    handleOnBlur = (item) => {
        if (this.state.focus === item) {
            this.setState({focus: null});
        }
    }

    handleRegCountrySelected(country) {
        this.props.setCountry(country);
    };
    //
    // validateForm() {
    //     const {entries, name, phone, email} = this.props;
    //     const nameValid = name && name.trim().length > 0;
    //     const phoneValid = phone && phone.trim().length > 0;
    //     const emailValid = email && email.trim().length > 0;
    //
    //     const {focus} = this.state;
    //     return {
    //         formValid: nameValid && phoneValid && emailValid && entries.length > 0,
    //         errors: {
    //             email: focus === 'email' && !emailValid,
    //             name: focus === 'name' && !nameValid,
    //             phone: focus == 'phone' && !phoneValid
    //         }
    //     };
    // }

    canAdminOverride() {
        const {currentToken} = this.props;
        if (!currentToken) {
            return false;
        }
        try {
            const auth = jwt_decode(currentToken);
            if (!auth.roles) {
                return false;
            }
            for(let i = 0; i < auth.roles.length; i++) {
                const role = auth.roles[i];
                if (role === 'ADMIN') {
                    return true;
                }
            }
        } catch (err) {
            console.log("Invalid JWT auth token", err);
        }
        return false;
    };

    createDeleteButton(entry) {
        const id = entry.tempId ? entry.tempId : entry.id;
        const clickHandler1 = () => {
            this.props.deleteEntry(id);
        };
        const title = entry.deleted ? "Undelete" : "Delete";
        const icon = entry.deleted ? <RestoreFromTrashOutlinedIcon /> : <DeleteOutlinedIcon />;
        return <Tooltip onClick={clickHandler1} title={title}><IconButton color="secondary">{icon}</IconButton></Tooltip>;
    }

    createEditButton(entry) {
        if (entry.deleted) {
            return null;
        }
        const clickHandler1 = () => {
            console.log("Would now edit entry " + JSON.stringify(entry));
            const category = this.props.instance.categories.find(c => c.id === entry.eventCategoryId);
            this.props.editEntry(entry, category);
        };
        return <Tooltip onClick={clickHandler1} title="Edit"><IconButton color="primary"><EditOutlinedIcon /></IconButton></Tooltip>;
    }

    submitEntry() {
        // Submit using a saga
        const registration = {
            name: this.props.name,
            email: this.props.email,
            phone: this.props.phone,
            country: this.props.country,
            entries: this.props.entries,
            tournamentInstanceId: this.props.instance.id,
            adminOverride: this.canAdminOverride()
        };

        this.props.submitRegistration(registration);
    };

    handleDialogClose() {
        this.props.openAddDialog(false);
    }

    handleAddButton() {
        this.props.openAddDialog(true, this.props.instance.categories[0]);
    }

    handleAddOrSaveEntry(entry) {
        this.props.addEntry(entry);
    }

    handleCloseSubmitDialog() {
        const status = this.props.submitDialogStatus;
        if (status === registrationFormActions.SUBMIT_REGISTRATION_STARTED) {
            return;
        }
        this.props.closeSubmitDialog();
    }

    render() {
        const {classes, entries, instance, name, country, phone, email, t, validation} = this.props;

        let entryList = [];

        let formEnabled = false;
        if (instance) {
            if (!instance.registrationOpen && !this.canAdminOverride()) {
                // TODO - only show this when it's a new entry, not when viewing an existing entry after logging in
                entryList = <Typography variant="h5" color="error">{t("registrationForm.registrationEnded")}</Typography>;
            } else {
                // otherwise we'll show the current list of entries, an "add" button, and a "submit" button
                formEnabled = true;
            }
        }

        if (formEnabled) {
            entryList = <Grid item xs={12}><Typography variant="h6">{t('registrationForm.emptyPlayerList')}</Typography></Grid>;
            if (entries && entries.length > 0) {
                entryList = [];
                instance.categories.forEach(category => {
                    const list = entries.filter(e => e.eventCategoryId === category.id);
                    if (list.length > 0) {
                        entryList.push(<Grid key={'category-' + category.id} item xs={12}><Typography variant="h6">{category.name}:</Typography></Grid>);
                    }
                    const createDeleteButton = (entry) => this.createDeleteButton(entry);
                    const createEditButton = (entry) => this.createEditButton(entry);
                    list.forEach((e, idx) => {
                        const deletedClass = e.deleted ? classes.deletedEntry : '';
                        entryList.push(<Grid key={'entry-' + idx} item xs={1}><Typography className={deletedClass} variant="body1">{idx + 1}</Typography></Grid>);
                        entryList.push(<Grid key={'entry-' + idx + '-player0'} item xs={4}><Typography className={deletedClass} variant="body1">{e.players[0].lastName}, {e.players[0].firstName} [{lookupCountry(e.players[0].country)}]</Typography></Grid>);
                        if (e.players.length === 2) {
                            entryList.push(<Grid key={'entry-' + idx + '-player1'} item xs={4}><Typography className={deletedClass} variant="body1">{e.players[1].lastName}, {e.players[1].firstName} [{lookupCountry(e.players[1].country)}]</Typography></Grid>);
                        } else {
                            entryList.push(<Grid key={'entry-' + idx + '-player1'} item xs={4}>&nbsp;</Grid>);
                        }
                        entryList.push(<Grid key={'entry-' + idx + '-icons'} item xs={3}>{createDeleteButton(e)}{createEditButton(e)}</Grid>);
                    });
                })
            }
        }

        const mobilePhone = t('registrationForm.mobile');

        const addEntryDialog = formEnabled && this.props.addDialogOpen ? (
            <AddEntryDialog addEntryHandler={(entry) => this.handleAddOrSaveEntry(entry)} defaultCountry={country} open={this.props.addDialogOpen} initialCategoryId={instance.categories[0].id} categories={instance.categories} />
        ) : null;

        const status = this.props.submitDialogStatus;
        const submitDialogProgress = status === registrationFormActions.SUBMIT_DIALOG_STATUS.IN_PROGRESS ? <LinearProgress /> : null;
        const closeSubmitDialogButtonEnabled = status === registrationFormActions.SUBMIT_DIALOG_STATUS.ERROR || status === registrationFormActions.SUBMIT_DIALOG_STATUS.SUCCESS;
        let submitDialogText = '';
        let submitDialogTextColor = 'initial';
        switch (status) {
            case registrationFormActions.SUBMIT_DIALOG_STATUS.SUCCESS:
                submitDialogText = t('registrationForm.formSuccess');
                break;
            case registrationFormActions.SUBMIT_DIALOG_STATUS.IN_PROGRESS:
                submitDialogText = t('registrationForm.submitting');
                break;
            case registrationFormActions.SUBMIT_DIALOG_STATUS.ERROR:
                submitDialogText = t('registrationForm.formError');
                submitDialogTextColor = 'error';
                break;
            case registrationFormActions.SUBMIT_DIALOG_STATUS.IDLE:
                break;
            default:
                break;
        }

        const excludes = ['GB'];
        return (
            <>
                <form noValidate autoComplete="off">
                    <Paper className={classes.root}>
                        <RegistrationToolbar title={t('registrationForm.title')}/>
                        <Typography className={classes.typographyTop} variant="h5" color="textPrimary">{t('registrationForm.contactInfo')}</Typography>
                        <Typography className={classes.typography} variant="body2" color="textSecondary">
                            {t('registrationForm.contactInfoBody')}
                        </Typography>
                        <div className={classes.grid}>
                            <Grid container spacing={4}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="registration-name"
                                        label={t('registrationForm.name')}
                                        value={name}
                                        className={classes.textField}
                                        onChange={(e) => this.handleChange('name', e)}
                                        margin="normal"
                                        error={validation.errors.name}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CountrySelect excludeCountries={excludes} onCountrySelected={(c) => this.handleRegCountrySelected(c)} country={country} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="registration-email"
                                        label={t('registrationForm.email')}
                                        value={email}
                                        className={classes.textField}
                                        onChange={(e) => this.handleChange('email', e)}
                                        margin="normal"
                                        error={validation.errors.email}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="registration-phone"
                                        label={mobilePhone}
                                        value={phone}
                                        className={classes.textField}
                                        onChange={(e) => this.handleChange('phone', e)}
                                        margin="normal"
                                        error={validation.errors.phone}
                                        fullWidth
                                        placeholder="+xxx 123456789"
                                    />
                                </Grid>
                            </Grid>
                            <Divider variant="middle" />
                        </div>
                    </Paper>
                    <Paper className={classes.bottomForm}>
                        <div className={classes.submitBar}>
                            <Typography className={classes.typographyTop} variant="h5" color="textPrimary">{t('registrationForm.entryList')}</Typography>
                            <div>&nbsp;</div>
                            <div>
                                <Button
                                    color="primary"
                                    className={classes.submitButton}
                                    onClick={() => this.handleAddButton()}
                                    startIcon={<AddIcon />}
                                    variant="contained"
                                    size="small"
                                >
                                    {t('registrationForm.addEntry')}
                                </Button>
                                <Button
                                    color="primary"
                                    className={classes.submitButton}
                                    disabled={!validation.formValid}
                                    onClick={() => this.submitEntry()}
                                    startIcon={<Icon>send</Icon>}
                                    variant="contained"
                                    size="small"
                                >
                                    {t('registrationForm.submitEntry')}
                                </Button>
                            </div>
                        </div>
                        <div className={classes.grid}>
                            <Grid container spacing={1}>
                                {entryList}
                            </Grid>
                        </div>
                        <div className={classes.grid}>&nbsp;</div>
                    </Paper>
                </form>
                {addEntryDialog}
                <Dialog open={this.props.submitDialogOpen} onClose={() => this.handleCloseSubmitDialog()} aria-labelledby="submit-dialog-title" aria-describedby="submit-dialog-description">
                    <DialogTitle id="submit-dialog-title">Submit Registration</DialogTitle>
                    {submitDialogProgress}
                    <DialogContent>
                        <DialogContentText color={submitDialogTextColor} id="submit-dialog-description">{submitDialogText}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={!closeSubmitDialogButtonEnabled} onClick={() => this.handleCloseSubmitDialog()} color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        instance: state.root.currentInstance,
        currentToken: state.root.currentToken,
        name: state.regForm.name,
        country: state.regForm.country,
        phone: state.regForm.phone,
        email: state.regForm.email,
        entries: state.regForm.entries,
        addDialogOpen: state.regForm.addDialogOpen,
        submitDialogOpen: state.regForm.submitDialogStatus !== registrationFormActions.SUBMIT_DIALOG_STATUS.IDLE,
        submitDialogStatus: state.regForm.submitDialogStatus,
        validation: state.regForm.validation
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        setCountry: (country) => dispatch({type: actions.SET_REGFORM_CONTACT, country: country}),
        setEmail: (email) => dispatch({type: actions.SET_REGFORM_CONTACT, email: email}),
        setPhone: (phone) => dispatch({type: actions.SET_REGFORM_CONTACT, phone: phone}),
        setName: (name) => dispatch({type: actions.SET_REGFORM_CONTACT, name: name}),
        addEntry: (entry) => dispatch({type: actions.ADD_OR_SAVE_ENTRY, entry: entry}),
        deleteEntry: (id) => dispatch({type: actions.DELETE_ENTRY, id: id}),
        openAddDialog: (open, category) => dispatch({type: actions.ADD_DIALOG_OPEN, open, category}),
        editEntry: (entry, category) => dispatch({type: actions.ADD_DIALOG_OPEN, open: true, entry, category}),
        submitRegistration: (registration) => dispatch({type: actions.SUBMIT_REGISTRATION, registration}),
        closeSubmitDialog: () => dispatch({type: actions.SUBMIT_REGISTRATION_DIALOG_CLOSE})
    };
}

export default withStyles(style)(withTranslation('messages')(connect(mapStateToProps, mapDispatchToProps)(RegistrationForm)));